export enum DashboardCardType {
  Event = "kongress",
  Infos = "",
  Advice = "beratungsleitfaden",
  MediFinder = "medifinder",
  Voucher = "gutschein",
}
